import React, { useContext, useEffect, useState } from "react";
import { Button, ButtonGroup, Spacer, Text } from "@chakra-ui/react";
import ConfirmationButton from "./buttons/ConfirmationButton";
import { ModalButton } from "./buttons/ModalButton"
import { BsArrowDown } from "react-icons/bs";
import { MdOutlineCancelPresentation } from "react-icons/md";
import { FaPrint, FaFileInvoice } from "react-icons/fa";
import AuthContext from "../contexts/Auth";
import client from "../helpers/Client";

function TicketActions({
  handleDelete,
  handleStart,
  handleComplete,
  handleCancel,
  handlePrint,
  handleCreateInvoice,
  ticket,
  children,
  handleScrollToTasks,
  ...props
}) {
  const auth = useContext(AuthContext);
  const isSuperUser = !!auth?.data?.user?.is_superuser;
  const userRoles = {
    manager: !!auth?.data?.user?.employee?.is_manager,
    servicer: !!auth?.data?.user?.is_servicer,
    technical: !!auth?.data?.user?.is_technical,
    reseller: !!auth?.data?.user?.is_reseller,
    employee: !!auth?.data?.user?.is_employee,
  };
  const [disabledButtons, setDisabledButtons] = useState(new Set());
  useEffect(() => {
    const load = async () => {
      try {
        if (isSuperUser) { setDisabledButtons(new Set()); return; }
        const roles = Object.entries(userRoles).filter(([_, v]) => v).map(([k]) => k);
        if (!roles.length) { setDisabledButtons(new Set()); return; }
        const { data } = await client.get(`/config/role-pages/?enabled=false`);
        const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
        const disabled = arr.filter(it => roles.includes(it.role_code) && it.button_id).map(it => it.button_id);
        setDisabledButtons(new Set(disabled));
      } catch (_) {
        setDisabledButtons(new Set());
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuperUser]);
  const allow = (id) => isSuperUser || !disabledButtons.has(id);
  return (
    <ButtonGroup direction="row" display="flex" size="sm" {...props}>
      {!ticket.started_at && (
        <ConfirmationButton
          callback={handleStart}
          title="BAŞLAT"
          verb="başlatmak"
          buttonColor="green"
          buttonVariant='solid'
          buttonTitle="BAŞLAT"
          data-tour-id="action-start"
          isVisible={allow('ticket.action.start')}
        />
      )}
      {ticket.started_at && (
        <ConfirmationButton
          callback={handleComplete}
          isDisabled={ticket.completed_at}
          title={ticket.completed_at ? "Tamamlandı" : "TAMAMLA"}
          verb="tamamlamak"
          buttonColor="red.500"
          buttonVariant={ticket.completed_at ? "solid" : "outline"}
          buttonTitle="TAMAMLA"
          data-tour-id="action-complete"
          isVisible={allow('ticket.action.complete')}
        />
      )}
      <Spacer />
      
      <Button
        rightIcon={<BsArrowDown />}
        onClick={handleScrollToTasks}
        colorScheme="teal"
        variant="outline"
        data-tour-id="go-subtasks"
        hidden={!allow('ticket.action.go_subtasks')}
      >
        Alt Görevlere Git
      </Button>
    

      {children}
    </ButtonGroup>
  );
}

export default TicketActions;
